<template>
    <el-text
        type="primary"
    >
        <font-awesome-icon icon="fa-solid fa-chevron-left" />&nbsp;
        <span tkey="返回控制室">{{label}}</span>
    </el-text>
</template>

<script setup>

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faChevronLeft)

const props = defineProps(["label"])

</script>

<style scoped>

</style>